module.exports = __webpack_public_path__ + "img/PPMPRA6.f34d8b8a.png";